export const VOTE_CATEGORIES = [
  { label: '娱乐', value: 'entertainment' },
  { label: '科技', value: 'tech' },
  { label: '生活', value: 'life' },
  { label: '美食', value: 'food' },
  { label: '体育', value: 'sports' },
  { label: '教育', value: 'education' },
  { label: '时尚', value: 'fashion' },
  { label: '游戏', value: 'games' },
  { label: '旅游', value: 'travel' },
  { label: '音乐', value: 'music' },
  { label: '电影', value: 'movie' },
  { label: '宠物', value: 'pets' }
]

export const getCategoryLabel = (value) => {
  const category = VOTE_CATEGORIES.find(c => c.value === value)
  return category ? category.label : '未知'
} 